module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07434_banner_800x600.5104bb1b.png";